import {
  FETCH_SETTINGS_REQUEST,
  FETCH_SETTINGS_SUCCESS,
  FETCH_SETTINGS_FAIL,
  SAVE_SETTINGS_REQUEST,
  SAVE_SETTINGS_SUCCESS,
  SAVE_SETTINGS_FAIL,
} from '../../store/types';

const initialState = {
  loading: false,
  error: null,
  settings: null,
  saved: false,
};

const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SETTINGS_REQUEST:
    case SAVE_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        saved: false,
      };

    case FETCH_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        settings: action.payload,
        error: null,
      };

    case SAVE_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        settings: action.payload,
        saved: true,
        error: null,
      };

    case FETCH_SETTINGS_FAIL:
    case SAVE_SETTINGS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        saved: false,
      };

    default:
      return state;
  }
};

export default settingsReducer;
